import React from 'react';
import { Card, Typography } from 'antd';
import { stringMixin, money } from "../../utils/strings";

const formatDt = (v) => {
    if (v < 0.01) {
        return 'Day';
    } else if (v < 0.02) {
        return 'Week';
    } else if (v < 0.1) {
        return 'Month';
    } else if (v < 0.5) {
        return 'Year';
    }
    return v;
}

const formatParams = (k, v) => {
    switch (k) {
        case 's0':
            return ['Initial Value', money(v, 0)];
        case 'mu':
            return ['Expected Return', stringMixin.pct(v)];
        case 'sigma':
            return ['Risk Tolerance', stringMixin.pct(v)];
        case 'n':
            return ['Time Steps', v];
        case 'dt':
            return ['Time Step', formatDt(v)];
        case 'n_simulations':
            return ['Total Simulations', v];
        case 'n_samples':
            return ['Samples Shown', v];
        case 'T':
            return ['Horizon', `${v} Years`];
        default:
            return [k, v];
    }
}

const MetaData = ({ process, finalParams, config }) => {
  return (
    <Card className={'gapless-y'} bordered={false} title={<Typography.Title level={5}>{process}</Typography.Title>} style={{ overflowX: 'auto' }}>

      <div style={{ display: 'table', width: '100%' }}>
        {Object.entries(finalParams).map(([key, value]) => (
          key === 'time_varying_params' ? (
              Object.values(value).length > 0 ? 'ADD HERE' : null
          ) : (
              key !== 'n_factors' ? (
                  <div key={key} style={{ display: 'table-row' }}>
                      <div style={{ display: 'table-cell', padding: '8px', textAlign: 'left' }}>
                          {formatParams(key, value)[0]}
                      </div>
                      <div style={{ display: 'table-cell', padding: '8px', textAlign: 'right' }}>
                          {formatParams(key, value)[1]}
                      </div>
                  </div>
              ) : null
          )
        ))}
      </div>
      <div style={{ display: 'table', width: '100%' }}>
        {Object.entries(config).map(([key, value]) => (
          <div key={key} style={{ display: 'table-row' }}>
              <div style={{ display: 'table-cell', padding: '8px', textAlign: 'left' }}>
                  {formatParams(key, value)[0]}
              </div>
              <div style={{ display: 'table-cell', padding: '8px', textAlign: 'right' }}>
                  {formatParams(key, value)[1]}
              </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default MetaData;
